require('./core');

require('./builders/cip_program_area_builder');
require('./builders/college_builder');
require('./builders/college_query_results_builder');
require('./builders/course_builder');
require('./builders/course_query_results_builder');
require('./builders/degree_completion_block_builder');
require('./builders/degree_completion_block_course_builder');
require('./builders/degree_completion_builder');
require('./builders/degree_completion_requirement_builder');
require('./builders/exam_builder');
require('./builders/exam_query_results_builder');
require('./builders/exam_type_builder');
require('./builders/grade_builder');
require('./builders/term_type_builder');
require('./builders/major_builder');
require('./builders/equivalent_courses_builder');
require('./builders/unapplied_credits_builder');

require('./models/transfer_transaction_model');
require('./models/transfer_course_transaction_model');
require('./models/transfer_college_transaction_model');
require('./models/transfer_major_transaction_model');

require('./commands/add_transfer_major_pending_course_command');
require('./commands/check_transfer_student_course_is_reviewed_command');
require('./commands/clear_transfer_datasources_command');
require('./commands/deselect_transfer_college_command');
require('./commands/deselect_transfer_course_command');
require('./commands/deselect_transfer_exam_command');
require('./commands/deselect_transfer_major_query_command');
require('./commands/load_transfer_category_majors_command');
require('./commands/load_transfer_cip_program_areas_command');
require('./commands/load_transfer_exam_types_command');
require('./commands/load_transfer_grades_command');
require('./commands/load_transfer_term_types_command');
require('./commands/load_transfer_major_degree_audit_command');
require('./commands/load_transfer_major_equivalent_courses_command');
require('./commands/load_transfer_major_details_command');
require('./commands/load_transfer_major_pending_courses_command');
require('./commands/load_transfer_major_related_careers_command');
require('./commands/load_transfer_progress_state_command');
require('./commands/load_transfer_selected_colleges_command');
require('./commands/load_transfer_selected_courses_command');
require('./commands/load_transfer_selected_exams_command');
require('./commands/load_transfer_selected_majors_command');
require('./commands/load_transfer_student_command');
require('./commands/load_transfer_suggested_majors_command');
require('./commands/remove_transfer_pending_course_command');
require('./commands/update_review_course_status_command');
require('./commands/search_transfer_colleges_command');
require('./commands/search_transfer_courses_command');
require('./commands/search_transfer_exams_command');
require('./commands/search_transfer_majors_command');
require('./commands/select_transfer_college_command');
require('./commands/select_transfer_course_command');
require('./commands/select_transfer_exam_command');
require('./commands/select_transfer_major_command');
require('./commands/update_transfer_exam_command');
require('./commands/update_transfer_progress_command');
require('./commands/update_transfer_student_course_command');

require('./components/college_tile/college_tile');
require('./components/course_tile/course_tile');
require('./components/degree_completion/degree_completion');
require('./components/disclaimer_language/disclaimer_language');
require('./components/exam_tile/exam_tile');
require('./components/exam_type_tile/exam_type_tile');
require('./components/major_checkbox/major_checkbox');
require('./components/major_tile/major_tile');
require('./components/majors_list/majors_list');
require('./components/pending_course_form_tile/pending_course_form_tile');
require('./components/progress_tabs/progress_tabs');
require('./components/suggested_majors/suggested_majors');
require('./directives/sync_hi_component_value');

require('./config/route_configuration');
require('./config/search_command_configuration');
require('./config/transfer_configuration');

require('./datasources/transfer_cip_program_areas_datasource');
require('./datasources/transfer_colleges_datasource');
require('./datasources/transfer_courses_datasource');
require('./datasources/transfer_degree_completion_datasource');
require('./datasources/transfer_equivalent_courses_datasource');
require('./datasources/transfer_exams_datasource');
require('./datasources/transfer_exam_types_datasource');
require('./datasources/transfer_grades_datasource');
require('./datasources/transfer_term_types_datasource');
require('./datasources/transfer_majors_datasource');
require('./datasources/transfer_pending_courses_datasource');

require('./strategies/pending_course_additional_info_strategy');

require('./notifications/first_course_added_notification');
require('./notifications/first_exam_added_notification');

require('./progression/transfer_credits_progress_state');
require('./progression/transfer_credits_progression');

require('./queries/transfer_degree_completion_query');
require('./queries/transfer_colleges_with_courses_query');
require('./queries/transfer_exam_type_with_exams_query');
require('./queries/transfer_grade_query');
require('./queries/transfer_term_type_query');
require('./queries/transfer_majors_categorized_query');
require('./queries/transfer_majors_found_query');
require('./queries/transfer_majors_selected_query');
require('./queries/transfer_majors_suggested_query');

require('./services/term_type_name_service');
require('./services/display_grade_service');

require('./views/choose_major/choose_major');
require('./views/credits_summary/credits_summary');
require('./views/exam_credits/exam_credits');
require('./views/major_details/major_details');
require('./views/majors_overview/majors_overview');
require('./views/past_courses/past_courses');
require('./views/refine_estimate/refine_estimate');
require('./views/transfer_credits/transfer_credits');



// WEBPACK FOOTER //
// ./app/lib/transfer/main.ts